/**
 * nativo.ts — ajustes para o app das lojas (Capacitor, Android/iOS).
 *
 * No app, a interface roda em https://localhost (Android) ou capacitor://localhost (iOS), então
 * as chamadas relativas a /api precisam ir para o servidor de produção. No navegador nada muda.
 */
import { Capacitor } from '@capacitor/core';

export const isNativo = Capacitor.isNativePlatform();

/** Servidor da API usado pelo app nativo. */
export const API_ORIGIN: string =
  ((import.meta as any).env?.VITE_API_ORIGIN as string | undefined)?.replace(/\/$/, '') || 'https://app.wastemap.com.br';

/** URL absoluta da API no app; relativa no navegador. */
export const urlApi = (caminho: string) => (isNativo && caminho.startsWith('/') ? API_ORIGIN + caminho : caminho);

/** Evento disparado pelo botão voltar do Android (o App trata a navegação interna). */
export const EVENTO_VOLTAR = 'wm:voltar';

export function instalarNativo() {
  if (!isNativo) return;

  // 1. fetch('/api/...') → servidor de produção
  const fetchOriginal = window.fetch.bind(window);
  window.fetch = (entrada: RequestInfo | URL, init?: RequestInit) => {
    if (typeof entrada === 'string' && entrada.startsWith('/api')) return fetchOriginal(API_ORIGIN + entrada, init);
    if (entrada instanceof Request) {
      const url = new URL(entrada.url);
      if (url.origin === window.location.origin && url.pathname.startsWith('/api')) {
        return fetchOriginal(new Request(API_ORIGIN + url.pathname + url.search, entrada), init);
      }
    }
    return fetchOriginal(entrada as any, init);
  };

  // 2. Barra de status, splash e botão voltar (carregados só no app)
  import('@capacitor/status-bar').then(({ StatusBar, Style }) => {
    StatusBar.setStyle({ style: Style.Default }).catch(() => {});
  }).catch(() => {});
  import('@capacitor/splash-screen').then(({ SplashScreen }) => {
    setTimeout(() => SplashScreen.hide().catch(() => {}), 600);
  }).catch(() => {});
  import('@capacitor/app').then(({ App }) => {
    App.addListener('backButton', () => {
      const evento = new CustomEvent(EVENTO_VOLTAR, { cancelable: true });
      // Se ninguém tratar (já está na tela inicial), sai do app
      if (window.dispatchEvent(evento)) App.exitApp();
    });
  }).catch(() => {});
}
